import { render, staticRenderFns } from "./FormControlModulestructureTableTargetColumn.vue?vue&type=template&id=b56446ae&scoped=true"
import script from "./FormControlModulestructureTableTargetColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureTableTargetColumn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlModulestructureTableTargetColumn.vue?vue&type=style&index=0&id=b56446ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56446ae",
  null
  
)

export default component.exports